<script lang="ts" setup>
import type {
    MetadataFragment,
    MetadataRelationshipFragment,
} from '~/lib/graphql/graphql.ts'

const baseUrl = useRuntimeConfig().public.imageBaseUrl

const props = defineProps<{
  item: MetadataRelationshipFragment | null
  class: string
  pictureClass?: string
  src?: string | undefined
  style?: string | undefined
  lazy?: boolean | undefined
}>()

const url = computed(() => {
    const item = props.item?.metadata as MetadataFragment | null
    const slug = item?.slug || item?.id
    if (!slug) return ''
    return baseUrl + '/' + slug
})

function getSourceSet(format: string) {
    const slug = props.item?.metadata?.slug || props.item?.metadata?.id
    const attrs = (props.item?.attributes || {})[format]
    const urlPrefix = baseUrl + '/' + slug
    return urlPrefix + '.' + format + '?key=' + (attrs?.small || 'small') + ', '
    + urlPrefix + '.' + format + '?key=' + (attrs?.medium || 'medium') + ' 2x, '
    + urlPrefix + '.' + format + '?key=' + (attrs?.large || 'large') + ' 3x'
}
</script>

<template>
  <picture
    v-if="url"
    :key="item?.metadata?.id || ''"
    :class="pictureClass"
  >
    <source
      :srcset="getSourceSet('webp')"
      type="image/webp"
    >
    <source
      :srcset="getSourceSet('jpg')"
      type="image/jpeg"
    >
    <img
      :loading="(lazy === undefined || lazy) ? 'lazy' : 'eager'"
      :src="url"
      :alt="item?.metadata?.slug || ''"
      :class="(props.class || '') + ' bg-gray-200'"
      :style="props.style || undefined"
    >
  </picture>
  <div
    v-else
    :class="(props.class || '') + ' bg-gray-200'"
    :style="props.style || undefined"
  />
</template>
